<template lang="pug">
  .content
    el-row.labelDiv
      el-col(:span="8")
        span.label Área:
        span {{ area }} ha
      el-col.inputDiv(:span="8")
        span.label Perímetro:
        span {{ perimetro }} m
      el-col(:span="8")
        span.label Município:
        span(v-if="!municipios.length") -
        span(v-for="municipio in municipios") {{ municipio.nome }}

</template>

<script>

export default {
  props: {
    area: {
      required: true
    },

    perimetro: {
      required: true
    },

    municipios: {
      required: true,
      type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
.label {
  font-weight: bold;
  margin-right: 10px;
}

span {
  font-size: 15px;
}

ul {
  list-style-type: none;
  margin-top: 0px;
}

.content {
  border: 2px #a9d3bc solid;
  border-radius: 10px;
  padding: 1rem;
}

@media (max-width: 780px) {
  .labelDiv {
    display: flex;
    flex-direction: column;
  }

  .inputDiv {
    width: 85%;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/arrecadacao/components/InformacoesAreaArrecadacao.vue